import beforeImage from "../../assets/Frame 150.svg";
import afterImage from "../../assets/Frame 151.svg";
import result21 from "../../assets/result21.svg";
import result22 from "../../assets/result22.svg";
import result31 from "../../assets/result31.svg";
import result32 from "../../assets/result32.svg";
import teethIcon from "../../assets/teeth_2.svg";
import calendarIcon from "../../assets/claneder.svg";

export const featureStrip = [
  {
    icon: teethIcon,
    title: "Same-Day Treatments",
    text: "Get quality care fast, with same-day appointments.",
  },
  {
    icon: null,
    title: "Advanced Aesthetic Dentistry",
    text: "Modern technology for beautiful, natural results.",
  },
  {
    icon: teethIcon,
    title: "Comfortable, Pain-Free Care",
    text: "We prioritize your comfort every step of the way.",
  },
  {
    icon: calendarIcon,
    title: "Emergency Appointments",
    text: "We're here when you need us most.",
  },
];

export const trustItems = [
  ["01", "Experienced Dentist", "Providing expert dental care backed by years of clinical experience."],
  ["02", "Modern Technology", "We use advanced equipment and innovative techniques for precise and effective treatment."],
  ["03", "Personalized Treatment", "Every patient receives an individual treatment plan tailored to their needs."],
  ["04", "Comfortable Environment", "We create a calm and friendly atmosphere so every visit feels comfortable and stress-free."],
];

export const results = [
  ["Teeth Whitening", beforeImage, afterImage],
  ["Porcelain Veneers", result21, result22],
  ["Dental Implants", result31, result32],
];
